export enum TextType {
  H1,
  H2,
  H3,
  H4,
  H4bold,
  H5,
  H5bold,
  H6,
  P1,
  P2,
}
export enum TextSize {
  default,
  large,
}
export enum TextSpacing {
  default,
  large,
}
export enum TextKerning {
  default,
  large,
}

export interface IProps {
  type?: TextType;
  text: any[];
  size?: TextSize;
  color?: string;
  rowSpacing?: TextSpacing;
  kerning?: TextKerning;
  spell?: number;
  textOnly?: boolean;
  useMarkup?: boolean;
}
export interface IStyled {
  type: TextType;
  size: TextSize;
  rowSpacing: TextSpacing;
  kerning: TextKerning;
}
